var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.eventState
    ? _c(
        "div",
        {
          staticClass: "d-flex justify-content-center",
          attrs: { title: _vm.eventDetails },
        },
        [
          _c("div", { class: ["state-icon", _vm.eventState] }, [
            _c("i", { class: ["fa", _vm.eventStateIcon] }),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }